(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/utils/wager.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/utils/wager.js');
"use strict";

const getWagerId = () => {
  var _svs$kenoXpress, _wager$properties;
  const wager = ((_svs$kenoXpress = svs.kenoXpress) === null || _svs$kenoXpress === void 0 || (_svs$kenoXpress = _svs$kenoXpress.data) === null || _svs$kenoXpress === void 0 ? void 0 : _svs$kenoXpress.wager) || {};
  return (_wager$properties = wager.properties) === null || _wager$properties === void 0 ? void 0 : _wager$properties.externalWagerId;
};
svs.kenoXpress.react.utils.wager = {
  getWager: () => {
    var _svs$kenoXpress2;
    return (_svs$kenoXpress2 = svs.kenoXpress) === null || _svs$kenoXpress2 === void 0 || (_svs$kenoXpress2 = _svs$kenoXpress2.data) === null || _svs$kenoXpress2 === void 0 ? void 0 : _svs$kenoXpress2.wager;
  },
  isWagerCompleted: () => {
    var _svs$kenoXpress3;
    const wager = ((_svs$kenoXpress3 = svs.kenoXpress) === null || _svs$kenoXpress3 === void 0 || (_svs$kenoXpress3 = _svs$kenoXpress3.data) === null || _svs$kenoXpress3 === void 0 ? void 0 : _svs$kenoXpress3.wager) || {};
    return Boolean(wager.completed);
  },
  getWagerId,
  resetWagerId: () => {
    if (getWagerId()) {
      svs.kenoXpress.data.wager = undefined;
    }
  },
  getGameCodeByWager: () => {
    if (getWagerId()) {
      return svs.kenoXpress.data.wager.properties.externalProductCode;
    }
  }
};

 })(window);